import { I18n } from "@assets/strings";
import { useObservable } from "micro-observables";
import React from "react";
import styled from "styled-components";
import { MaterialTextInput } from "@ui/components/inputs/materialTextInput";
import { useEditorController } from "@ui/pages/lms/article/articleEditorPage/articleEditorController/editorControllerContext";

type TitleEditorProps = React.HTMLAttributes<HTMLDivElement>;

export const TitleEditor: React.FC<TitleEditorProps> = ({ ...htmlProps }) => {
	const controller = useEditorController();
	const article = useObservable(controller.article);

	return (
		<BigTextInput
			{...htmlProps}
			placeholder={I18n.t("article.editor.title.placeholder") + "*"}
			value={article.title}
			onChange={(v) => controller.setTitle(v)}
		/>
	);
};

const BigTextInput = styled(MaterialTextInput)`
	input,
	input::placeholder {
		font-size: 1.875rem;
		font-weight: bold;
	}
`;
